import React from "react";

import {
  t,
  HEADING1,
  HEADING2,
  HEADING3,
  HEADING4,
  L1,
  L2,
  L3,
  L4,
  L5,
  L6,
  HEADING5,
  A1,
  A2,
  A3,
  A4,
  A5,
  A6,
  A7,
  A8,
  A9,
} from "../../translations/AboutUs/FinancialPerformance";

function FinancialPerformance() {
  return (
    <div
      className="financial-performance"
      style={{
        width: "80%",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        flexDirection: "column",
        paddingRight: 10,
      }}
    >
      <div
        className="a-large"
        style={{
          fontWeight: 600,
          textAlign: "left",
          paddingBottom: 15,
        }}
      >
        {t(HEADING1)}
      </div>
      <div
        className="a-normal"
        style={{
          fontWeight: 500,
          textAlign: "left",
          paddingBottom: 15,
        }}
      >
        {t(HEADING2)}
      </div>
      <div className="a-normal" style={{ display: "flex" }}>
        <div
          style={{
            padding: "10px",
            textAlign: "center",
            border: "1px solid lightgrey",
            borderBottom: "none",
          }}
        >
          {t(HEADING3)}
        </div>
        <div
          style={{
            padding: "10px",
            textAlign: "center",
            border: "1px solid lightgrey",
            borderBottom: "none",
          }}
        >
          2016-17
        </div>
      </div>
      <table>
        <tbody>
          <tr>
            <th
              colSpan={2}
              style={{ backgroundColor: "#e5f3ff", fontWeight: 700 }}
            >
              {t(HEADING4)}
            </th>
          </tr>
          <tr>
            <td>{t(L1)}</td>
            <td>291.89</td>
          </tr>
          <tr>
            <td>{t(L2)}</td>
            <td>199.27</td>
          </tr>
          <tr>
            <td>{t(L3)}</td>
            <td>157.69</td>
          </tr>
          <tr>
            <td>{t(L4)}</td>
            <td>777.64</td>
          </tr>
          <tr>
            <td>{t(L5)}</td>
            <td>0</td>
          </tr>
          <tr>
            <th style={{ backgroundColor: "#e5f3ff", fontWeight: 700 }}>
              {t(L6)}
            </th>
            <th style={{ backgroundColor: "#e5f3ff", fontWeight: 700 }}>
              1426.49
            </th>
          </tr>
        </tbody>
      </table>
      <div style={{ paddingBottom: 15 }} />
      <table>
        <tbody>
          <tr>
            <th
              colSpan={2}
              style={{ backgroundColor: "#e5f3ff", fontWeight: 700 }}
            >
              {t(HEADING5)}
            </th>
          </tr>
          <tr>
            <td>{t(A1)}</td>
            <td>2460.53</td>
          </tr>
          <tr>
            <td>{t(A2)}</td>
            <td>1691.93</td>
          </tr>
          <tr>
            <td>{t(A3)}</td>
            <td>768.60</td>
          </tr>
          <tr>
            <td>{t(A4)}</td>
            <td>124.11</td>
          </tr>
          <tr>
            <td>{t(A5)}</td>
            <td>0.05</td>
          </tr>
          <tr>
            <td>{t(A6)}</td>
            <td>352.25</td>
          </tr>
          <tr>
            <td>{t(A7)}</td>
            <td>0.61</td>
          </tr>
          <tr>
            <td>{t(A8)}</td>
            <td>180.87</td>
          </tr>
          <tr>
            <th style={{ backgroundColor: "#e5f3ff", fontWeight: 700 }}>
              {t(A9)}
            </th>
            <th style={{ backgroundColor: "#e5f3ff", fontWeight: 700 }}>
              1426.49
            </th>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default FinancialPerformance;
